import React from 'react';

import { Flex } from '@chakra-ui/react';
import { ICellRendererParams } from 'ag-grid-community';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { OneOnOneInsightsTData } from '../../features/AgGridTable/services';
import ColoredNullValueComponent from './ColoredNullValueComponent';

const PlainTextCell = ({ value }: ICellRendererParams<OneOnOneInsightsTData, number>) => {
  const textColor = value > 50 ? '#44812F' : '#B96400';
  return (
    <Flex w="100%" h="100%" alignItems="center">
      <TextBodyMedium color={textColor}>{value !== null ? value : <ColoredNullValueComponent />}</TextBodyMedium>
    </Flex>
  );
};

export { PlainTextCell };
